import { render, staticRenderFns } from "./ElsaSection.vue?vue&type=template&id=b020412a&scoped=true&"
import script from "./ElsaSection.vue?vue&type=script&lang=js&"
export * from "./ElsaSection.vue?vue&type=script&lang=js&"
import style0 from "./ElsaSection.vue?vue&type=style&index=0&id=b020412a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b020412a",
  null
  
)

export default component.exports